import styles from "./taskcard.module.css";
import { Checkbox, FormControlLabel } from "@mui/material";
import { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { AddLogCallAPI } from "../../../../components/AddLogs";

const TaskCard = ({ item, index, setAllData, activeAccordion, setActiveAccordion }) => {
  const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();
  const [tasks, setTasks] = useState({ completed: 0, total: 0 });
  const isActive = activeAccordion === index;

  const toggle = () => {
    setActiveAccordion(isActive ? null : index);
  }

  useEffect(() => {
    let completedTask = item?.today_check_list?.filter((i) => i?.is_checked === 1);
    setTasks({ completed: completedTask?.length, total: item?.today_check_list?.length });
  }, [item]);

  const handleCheckToggle = async (e, task) => {
    let newItem = item?.today_check_list?.map((i) => {
      if (i?.id == task?.id)
        return { ...i, is_checked: e.target.checked ? 1 : 0 };
      return i;
    });

    setAllData((prev) => {
      return prev?.map((i) => {
        if (i?.id === item?.id) return { ...i, today_check_list: newItem };
        return i;
      });
    });

    let isChecked = e.target.checked;

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    axios.put(process.env.REACT_APP_CASE_API_URL + "v1/check-list/" + task?.id, { is_checked: e.target.checked ? 1 : 0 }, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(() => {

      let logData = {
        title: "A task has been checked.",
        description: [
          "Task Name: " + task.task_list,
          "List Name: " + item.title
        ],
      };

      if (isChecked)
        AddLogCallAPI(logData, token);
    }).catch(() => { });
  }

  return (<div className={styles.AccordionSecMain}>
    <div className={`${styles.AccordionList}`} key={item?.id}>
      <div className={`${styles.AccordionListHead} ${isActive ? styles.Open : ""}`} onClick={() => toggle(index)}>
        <div>
          <p className={`${styles.Title}`}>
            <span>Task Name</span>
            {item?.title}
          </p>
          <p className={`${styles.SubTitle}`}>
            <span>Completed Tasks</span>
            {tasks?.completed}/{tasks?.total}
            {tasks?.completed < tasks?.total && (<img src="/static/img/warning.png" className={`${styles.StatusIMG}`} alt="warning" />)}
            {tasks?.completed === tasks?.total && (<img src="/static/img/success.png" className={`${styles.StatusIMG}`} alt="Completed" />)}
          </p>
          <img src="/static/img/downTriangle.svg" />
        </div>
        <p className={`${styles.FrequencyText}`}>
          {item?.days?.map((d) => d.slice(0, 3)).join(", ")}
        </p>
      </div>
      <div className={`${styles.AccordionListBody} ${isActive ? styles.Open : ""}`}>
        {item?.today_check_list.map((task) => (<>
          <div key={task.id} className={`${styles.Checklist}`}>
            <FormControlLabel
              className={styles.ProsCheckSec}
              control={<Checkbox checked={!!task.is_checked} onChange={(e) => handleCheckToggle(e, task)} disabled={!(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("task-checklist:update") > -1)} />}
              label={task.is_checked ? (<del>{task.task_list}</del>) : (task.task_list)}
            />
          </div>
        </>))}
      </div>
    </div>
  </div>);
};

export default TaskCard;